export default __webpack_public_path__ + "static/media/sales-funnel-canvas.b82e849a.svg";